<script>
  //// imports
  import { Modal } from "carbon-components-svelte";
  import { Button, Pagination } from "paxray-components-svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import ActivityModal from "./ActivityModal.svelte";
  import { CLOSE_ICON, EDIT_ICON, PLUS_ICON } from "@utils/icons.js";

  export let activities = [];
  export let selectedActivity = "";
  export let analysisid;
  export let windowTitles = [];
  export let startEvents = [];
  export let endEvents = [];
  export let displayCount = 20;
  export let updateActivity = () => {};
  export let saveActivity = () => {};
  export let primaryWindows = [];
  export let editActivityName = "";
  export let editActivityColor = "#93EDA3";
  let modalOpen = false;

  let currentPage = 1;
  let displayedActivities = [];

  let deleteModalOpen = false;
  let searchTerm = "";
  let editActivityId = "";
  let filteredActivities = [];

  $: updateDisplay(currentPage, searchTerm, activities);

  function deleteActivity() {
    fetchWithSession(`/api/analysis/deleteMappedActivity`, {
      method: "POST",
      body: JSON.stringify({
        activityid: selectedActivity,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        activities = activities.filter((app) => app.id !== selectedActivity);
        selectedActivity = "";
        deleteModalOpen = false;
      });
  }

  // function getRandomColor() {
  //   return (
  //     "#" +
  //     Math.floor(Math.random() * 0x1000000)
  //       .toString(16)
  //       .padEnd(6, "0")
  //   );
  // }

  function selectActivity(app) {
    if (selectedActivity === app.id) selectedActivity = "";
    else selectedActivity = app.id;
  }

  function updateDisplay(currentPage, search, sortedAppData) {
    if (search) {
      filteredActivities = sortedAppData.filter((app) =>
        app.activityname.toLowerCase().includes(search.toLowerCase()),
      );
    } else {
      filteredActivities = sortedAppData;
    }
    while (filteredActivities.length < (currentPage - 1) * displayCount) {
      currentPage--;
    }
    displayedActivities = filteredActivities.slice(
      (currentPage - 1) * displayCount,
      currentPage * displayCount,
    );
  }
</script>

<div class="app_selection_wrapper">
  <div class="top_bar">
    <div class="search_wrapper">
      <div class="search">
        <div class="searchicon">
          <svg
            height="100%"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
              fill="#1C1C20"
            />
          </svg>
        </div>
        <input
          type="text"
          bind:value={searchTerm}
          placeholder="Search for Activity"
        />
      </div>
    </div>
    <div>
      <Button
        kind="secondary"
        iconDescription="New"
        icon={PLUS_ICON}
        on:click={() => {
          modalOpen = true;
          editActivityName = "";
          editActivityColor = "#93EDA3";
          editActivityId = "";
        }}
      />
    </div>
  </div>
  <div class="activities">
    {#each displayedActivities as activity}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="activity"
        on:click={() => {
          selectActivity(activity);
        }}
      >
        <div class="color" style="background-color: {activity.color};"></div>
        <div
          class="activity_name"
          style={selectedActivity == activity.id
            ? "border:1px solid black;"
            : ""}
        >
          <span>{activity.activityname}</span>
        </div>
        <div>
          <Button
            kind="secondary"
            iconDescription="Edit"
            icon={EDIT_ICON}
            on:click={(e) => {
              e.stopPropagation();
              selectedActivity = activity.id;
              modalOpen = true;
              editActivityName = activity.activityname;
              editActivityColor = activity.color;
              editActivityId = activity.id;
            }}
          />
          <Button
            kind="secondary"
            iconDescription="Delete"
            icon={CLOSE_ICON}
            on:click={(e) => {
              e.stopPropagation();
              selectedActivity = activity.id;
              deleteModalOpen = true;
            }}
          />
        </div>
      </div>
    {/each}
  </div>

  <Pagination
    basic
    totalItems={filteredActivities.length}
    bind:page={currentPage}
    pageSize={displayCount}
  />
</div>

<Modal
  bind:open={deleteModalOpen}
  modalHeading="Delete Activity"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  danger
  on:click:button--secondary={() => {
    deleteModalOpen = false;
  }}
  on:submit={() => {
    deleteActivity();
  }}
>
  <p>Are you sure you want to delete this activity?</p>
</Modal>

<ActivityModal
  bind:modalOpen
  bind:editActivityName
  bind:editActivityColor
  bind:editActivityId
  {startEvents}
  {endEvents}
  {windowTitles}
  {analysisid}
  {updateActivity}
  {saveActivity}
  {primaryWindows}
></ActivityModal>

<style>
  .app_selection_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .search_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 1;
  }

  .search {
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
  }

  input:focus,
  input:active {
    outline: none;
  }

  .top_bar {
    display: flex;
    gap: 0.5rem;
  }

  .activities {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .activity {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
  }

  .color {
    height: 3rem;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
  }

  .activity_name {
    display: flex;
    height: 3rem;
    align-items: center;
    flex-grow: 1;
    flex-shrink: 1;
    background-color: var(--pax-smoke);
    padding: 0 1rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .activity_name span {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1rem 0;
  }
</style>
